import { Component, OnDestroy, Input, ViewChild } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { WidgetComponent } from '../core/widget.component';
import { ChartLineComponent } from './chartline.component';
import { ReportsService } from '../../../@apiClient/extensions';
import { DashboardDataService } from '../../dashboard-data.service';

@Component({
  selector: 'app-chart-widget-tiny',
  styleUrls: ['./chartwidgettiny.component.scss'],
  template: `
    <nb-card size="xsmall">
      <nb-card-header>
        <span>{{title}}</span>
        <div class="dropdown ghost-dropdown" ngbDropdown>
          <button type="button" class="btn btn-sm" ngbDropdownToggle
                  [ngClass]="{ 'btn-success': currentTheme == 'default', 'btn-primary': currentTheme != 'default'}">
            {{ type }}
          </button>
          <ul ngbDropdownMenu class="dropdown-menu">
            <li class="dropdown-item" *ngFor="let t of types" (click)="type = t">{{ t }}</li>
          </ul>
        </div>
      </nb-card-header>
      <nb-card-body class="p-0">
        <app-chart-line-tiny [data]="data" chart></app-chart-line-tiny>
      </nb-card-body>
    </nb-card>
  `,
})
export class ChartWidgetTinyComponent extends WidgetComponent implements OnDestroy {
  type = 'month';
  types = ['week', 'month', 'year'];
  data:Array<number>;
  currentTheme: string;
  themeSubscription: any;

  @Input() title = '';
  @Input() value:Array<{series:string, values:Array<number>}> = [];

  @ViewChild(ChartLineComponent, { static: true }) chart: ChartLineComponent;
  constructor(private themeService: NbThemeService,
              private _data: DashboardDataService,
              reportsService: ReportsService) {
                super(reportsService);

    this.themeSubscription = this.themeService.getJsTheme().subscribe(theme => {
      this.currentTheme = theme.name;
    });
  }
  ngOnInit() {
    //const values = this._data.getWidgetData(this.valuesName);
    this.types = this.value.map( v => v.series);
    this.type = this.types[0];
    this.data = this.value[0].values;

  }
  ngAfterViewInit(){
    this.chart.ngAfterViewInit();
  }
  ngOnDestroy() {
    this.themeSubscription.unsubscribe();
  }
}
